import { FormattedMessage } from 'react-intl';
import StepItem from '../stepItem/StepItem';
import { Button, Icon } from '@iwoca/orion';
import messages from './SignDocumentAction.messages';
import styles from './SignDocumentAction.module.css';
import { FormattedName } from '@iwIntlProvider/FormattedName';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { FUNDING_STEP_ACTION } from '../../Funding.actions';
import { getCountry } from '@iwIntlProvider/CountryProvider';
import { TSignDocument } from './SignDocumentsHelper';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    handleFundingStepAction: (step: TSignDocument) => {
        let stepType = 'SIGN_DOCUMENT';
        if (step.signatureMethod === 'WET') {
            stepType = 'SIGN_DOCUMENT_WET';
        }
        dispatch({
            type: FUNDING_STEP_ACTION,
            step: stepType,
            signDocumentAction: step
        });
    },
    downloadSignDocument: (step: TSignDocument) => {
        dispatch({
            type: FUNDING_STEP_ACTION,
            step: 'VIEW_SIGN_DOCUMENT',
            signDocumentAction: step
        });
    }
});

const SignDocumentAction = ({
    step,
    handleFundingStepAction,
    downloadSignDocument
}: {
    step: TSignDocument;
} & ReturnType<typeof mapDispatchToProps>) => {
    const documentType = step.type.toLowerCase();

    const formattedPersonToSign = (
        <FormattedName
            possessive={true}
            firstName={step.personToSign.first_name}
            lastName={step.personToSign.last_name}
        />
    );
    const requiresNonApplicantSigning = step.requiresNonApplicantSigning;

    const title =
        step.type === 'guarantee' ? (
            <FormattedMessage
                {...messages[`${documentType}_label` as keyof typeof messages]}
                values={{
                    requiresNonApplicantSigning,
                    formattedPersonToSign
                }}
            />
        ) : (
            <FormattedMessage
                {...messages[`${documentType}_label` as keyof typeof messages]}
            />
        );

    const caption =
        step.status === 'REQUIRED' ? (
            step.signatureMethod === 'WET' ? (
                <>
                    <FormattedMessage
                        {...messages.wetSignDocumentsFooter}
                        values={{
                            documentsLink: (
                                <a
                                    className={styles.documentTypeFooterLink}
                                    href={`mailto:${messages.documentsEmailAddress.defaultMessage}`}
                                >
                                    <FormattedMessage
                                        {...messages.documentsEmailAddress}
                                    />
                                </a>
                            )
                        }}
                    />
                    {/* DE requires post address to be shown */}
                    {getCountry() === 'DE' && (
                        <div className={styles.postalAddress}>
                            <FormattedMessage
                                {...messages.companyName}
                                tagName="div"
                            />
                            <FormattedMessage
                                {...messages.addressLineOne}
                                tagName="div"
                            />
                            <FormattedMessage
                                {...messages.addressLineTwo}
                                tagName="div"
                            />
                            <FormattedMessage
                                {...messages.addressLineThree}
                                tagName="div"
                            />
                        </div>
                    )}
                </>
            ) : (
                <FormattedMessage {...messages.caption} />
            )
        ) : (
            <FormattedMessage {...messages.caption_completed} />
        );

    return (
        <StepItem
            title={title}
            caption={caption}
            action={
                step.status === 'COMPLETED' ? (
                    <div>
                        <Button
                            variant="tertiary"
                            className={styles.actionIcon}
                            onClick={() => downloadSignDocument(step)}
                            aria-label="download document"
                        >
                            <Icon
                                icon="download"
                                height="24"
                                width="24"
                                fill="rgba(16, 47, 86, 1)"
                                xlinkTitle="download"
                            />
                        </Button>
                    </div>
                ) : (
                    <Button
                        variant="primary"
                        onClick={() => handleFundingStepAction(step)}
                    >
                        {step.signatureMethod === 'WET' ? (
                            <FormattedMessage {...messages.action_wet} />
                        ) : (
                            <FormattedMessage {...messages.action} />
                        )}
                    </Button>
                )
            }
        />
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(null, mapDispatchToProps)(SignDocumentAction);
